import * as React from "react";
const SvgMore = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 21, height: 20, viewBox: "0 0 21 20", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "none", d: "M3 4.167h15M3 10h15M3 15.833h15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgMore;
